import { MutationTree } from "vuex";
// interfaces
import { AgreementI } from "../interfaces/agreements.interface";

export enum AgreementMutations {
}

export const mutations: MutationTree<AgreementI> = {
}
